(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bandz-fit-room"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bandz-fit-room'))customElements.define('bandz-fit-room',class extends HTMLElement {
    connectedCallback(){
      this.events?.abort();this.events=new AbortController();const opts={signal:this.events.signal};
      this.data=JSON.parse(this.querySelector('[data-fit-data]').textContent);this.products=this.data.products;this.top='sweatshirt';this.angle=0;this.busy=false;
      this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.dialog=this.querySelector('[data-fit-dialog]');this.error=this.querySelector('[data-fit-error]');
      this.items=Object.fromEntries([...this.querySelectorAll('[data-fit-item]')].map(el=>[el.dataset.fitItem,el]));
      this.selects=Object.fromEntries(Object.entries(this.items).map(([key,el])=>[key,el.querySelector('select')]));
      this.querySelectorAll('[data-fit-top]').forEach(button=>button.addEventListener('click',()=>{if(!this.busy){this.top=button.dataset.fitTop;this.render();this.animateModel();}},opts));
      this.querySelectorAll('[data-fit-angle]').forEach(button=>button.addEventListener('click',()=>{this.angle=Number(button.dataset.fitAngle);this.render();this.animateModel();},opts));
      Object.entries(this.selects).forEach(([key,select])=>select.addEventListener('change',()=>{this.updatePrice(key);this.renderTotal();},opts));
      this.querySelectorAll('[data-fit-open]').forEach(button=>button.addEventListener('click',()=>this.open(button.dataset.fitOpen==='top'?this.top:button.dataset.fitOpen),opts));
      this.querySelector('[data-fit-close]').addEventListener('click',()=>this.dialog.close(),opts);
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const b=this.dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)this.dialog.close();}},opts);
      this.querySelector('[data-fit-dialog-size]').addEventListener('change',event=>{const key=this.dialogKey;this.selects[key].value=event.target.value;this.updatePrice(key);this.renderTotal();this.querySelector('[data-fit-dialog-price]').textContent=this.items[key].querySelector('[data-fit-price]').textContent;},opts);
      this.querySelector('[data-fit-dialog-add]').addEventListener('click',()=>this.add([this.dialogKey]),opts);
      Object.entries(this.items).forEach(([key,el])=>el.querySelector('form').addEventListener('submit',event=>{event.preventDefault();this.add([key]);},opts));
      this.querySelector('[data-fit-full]').addEventListener('click',()=>this.add([this.top,'shorts']),opts);
      const stage=this.querySelector('[data-fit-stage]');let start;
      stage.addEventListener('touchstart',event=>{start=event.touches.length===1?event.touches[0]:null;},{...opts,passive:true});
      stage.addEventListener('touchcancel',()=>{start=null;},opts);
      stage.addEventListener('touchend',event=>{if(!start)return;const end=event.changedTouches[0],dx=end.clientX-start.clientX,dy=end.clientY-start.clientY;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.4){this.angle=(this.angle+(dx<0?1:2))%3;this.render();this.animateModel();this.swipedAt=performance.now();}},{...opts,passive:true});
      stage.addEventListener('click',event=>{if(performance.now()-(this.swipedAt||-Infinity)<450){event.preventDefault();event.stopPropagation();}},{...opts,capture:true});
      this.querySelector('[data-fit-purchase]').hidden=false;this.render();
    }
    disconnectedCallback(){this.events?.abort();this.animation?.cancel();this.dialog?.close();}
    updatePrice(key){const option=this.selects[key].selectedOptions[0];if(option?.value)this.items[key].querySelector('[data-fit-price]').textContent=option.dataset.money;}
    render(){
      this.querySelectorAll('[data-fit-top]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.fitTop===this.top)));
      this.querySelectorAll('[data-fit-angle]').forEach(el=>el.setAttribute('aria-pressed',String(Number(el.dataset.fitAngle)===this.angle)));
      Object.entries(this.items).forEach(([key,el])=>el.hidden=key!=='shorts'&&key!==this.top);
      this.querySelectorAll('[data-fit-detail]').forEach(el=>el.hidden=el.dataset.fitDetail!=='shorts'&&el.dataset.fitDetail!==this.top);
      const angleLabel=this.querySelector(`[data-fit-angle="${this.angle}"]`).textContent;
      this.querySelectorAll('[data-fit-strip]').forEach(img=>{img.hidden=img.dataset.fitStrip!==this.top;img.style.setProperty('--fit-offset',`${this.angle*-100/3}%`);img.alt=this.data.messages.model.replace('[product]',this.products[img.dataset.fitStrip].title).replace('[angle]',angleLabel);});
      this.renderTotal();
    }
    renderTotal(){
      const total=[this.top,'shorts'].reduce((sum,key)=>sum+(Number(this.selects[key].selectedOptions[0]?.dataset.price)||this.products[key].price),0);
      this.querySelector('[data-fit-total]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'USD',currencyDisplay:'code'}).format(total/100);
      this.querySelector('[data-fit-full]').disabled=this.busy||![this.top,'shorts'].every(key=>this.products[key].available);
    }
    animateModel(){if(this.motion.matches||this.closest('.society')?.dataset.motion==='false')return;this.animation?.cancel();this.animation=this.querySelector(`[data-fit-strip="${this.top}"]`).animate([{opacity:.45},{opacity:1}],{duration:260,easing:'ease-out'});}
    open(key){
      if(this.busy)return;this.dialogKey=key;const product=this.products[key];
      this.querySelector('[data-fit-dialog-title]').textContent=product.title;this.querySelector('[data-fit-dialog-price]').textContent=this.items[key].querySelector('[data-fit-price]').textContent;
      const photos=this.querySelector('[data-fit-photos]');photos.replaceChildren();product.images.forEach((url,index)=>{const img=document.createElement('img');img.src=url;img.alt=`${product.title} — ${this.data.messages.photo.replace('[number]',String(index+1))}`;img.width=550;img.height=550;img.loading='lazy';photos.append(img);});
      const select=this.querySelector('[data-fit-dialog-size]');select.replaceChildren(...[...this.selects[key].options].map(option=>option.cloneNode(true)));select.value=this.selects[key].value;select.disabled=!product.available;
      this.querySelector('[data-fit-dialog-add]').disabled=!product.available;this.querySelector('[data-fit-dialog-link]').href=product.url;this.querySelector('[data-fit-dialog-error]').hidden=true;this.dialog.showModal();
    }
    async add(keys){
      if(this.busy)return;this.error.hidden=true;const dialogError=this.querySelector('[data-fit-dialog-error]');dialogError.hidden=true;
      for(const key of keys){const select=this.selects[key];if(!this.products[key].available||!select.value||select.selectedOptions[0].disabled){const message=keys.length>1?this.data.messages.sizes:this.data.messages.size;this.error.textContent=message;this.error.hidden=false;if(this.dialog.open){dialogError.textContent=message;dialogError.hidden=false;this.querySelector('[data-fit-dialog-size]').focus();}else{select.focus();select.reportValidity();}return;}}
      const items=keys.map(key=>({id:Number(this.selects[key].value),quantity:1}));this.busy=true;
      const buttons=[...this.querySelectorAll('[data-fit-full],[data-fit-add-single],[data-fit-dialog-add],[data-fit-top]')];const states=buttons.map(button=>button.disabled);buttons.forEach(button=>button.disabled=true);
      try{
        const response=await fetch(this.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if(!response.ok)throw new Error('cart');
        const result=await response.json();if(!Array.isArray(result.items)||result.items.length!==items.length)throw new Error('cart');
        window.location.assign(this.dataset.cartUrl);
      }catch{
        this.error.textContent=this.dataset.error;this.error.hidden=false;this.querySelector('[data-fit-check-cart]').hidden=false;
        if(this.dialog.open){dialogError.textContent=this.dataset.error;dialogError.hidden=false;}
        this.busy=false;buttons.forEach((button,index)=>button.disabled=states[index]);this.renderTotal();
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bandz-journal-magazine"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bandz-magazine')) {
    customElements.define('bandz-magazine', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.book = this.querySelector('[data-mag-book]');
        this.pages = [...this.querySelectorAll('[data-mag-page]')];
        this.prev = this.querySelector('[data-mag-prev]');
        this.next = this.querySelector('[data-mag-next]');
        this.status = this.querySelector('[data-mag-status]');
        this.index = 0;
        this.busy = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 749px)');
        this.setAttribute('data-mag-ready', '');
        this.show(0);
        this.querySelector('[data-mag-controls]').hidden = this.pages.length < 2;
        this.prev.addEventListener('click', () => this.turn(-1), options);
        this.next.addEventListener('click', () => this.turn(1), options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.turn(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        let start;
        this.lastSwipe = -Infinity;
        this.book.addEventListener('touchstart', event => { start = event.touches.length === 1 ? event.touches[0] : null; }, { ...options, passive: true });
        this.book.addEventListener('touchcancel', () => { start = null; }, options);
        this.book.addEventListener('touchend', event => {
          if (!start) return;
          const end = event.changedTouches[0];
          const dx = end.clientX - start.clientX;
          const dy = end.clientY - start.clientY;
          start = null;
          if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.35) return;
          this.lastSwipe = performance.now();
          this.turn(dx < 0 ? 1 : -1);
        }, { ...options, passive: true });
        this.book.addEventListener('click', event => {
          if (performance.now() - this.lastSwipe < 420) event.preventDefault();
        }, options);
      }
      show(index) {
        this.index = index;
        this.pages.forEach((page, i) => { page.hidden = i !== index; page.inert = i !== index; });
        this.prev.disabled = index === 0;
        this.next.disabled = index === this.pages.length - 1;
        this.status.textContent = this.dataset.pageLabel.replace('[current]', String(index + 1).padStart(2,'0')).replace('[total]', String(this.pages.length).padStart(2,'0'));
      }
      async turn(direction) {
        const next = this.index + direction;
        if (this.busy || next < 0 || next >= this.pages.length) return;
        const current = this.pages[this.index];
        if (current.contains(document.activeElement)) this.book.focus({ preventScroll: true });
        if (this.motion.matches || this.closest('.society')?.dataset.motion === 'false') { this.show(next); return; }
        this.busy = true;
        const source = direction > 0 ? current : this.pages[next];
        const leaf = document.createElement('div');
        leaf.className = 'bj-magazine__leaf';
        leaf.inert = true;
        leaf.setAttribute('aria-hidden', 'true');
        const clone = (this.mobile.matches ? source : source.querySelector('.bj-card__copy')).cloneNode(true);
        clone.hidden = false;
        leaf.append(clone);
        this.show(next);
        this.book.append(leaf);
        this.leaf = leaf;
        this.animation = leaf.animate(direction > 0 ? [
          { transform: 'rotateY(0deg)', opacity: 1 },
          { transform: 'rotateY(-85deg)', opacity: 1, offset: .68 },
          { transform: 'rotateY(-165deg)', opacity: 0 }
        ] : [
          { transform: 'rotateY(-165deg)', opacity: 0 },
          { transform: 'rotateY(-85deg)', opacity: 1, offset: .32 },
          { transform: 'rotateY(0deg)', opacity: 1 }
        ], { duration: 720, easing: 'cubic-bezier(.3,.65,.25,1)' });
        try { await this.animation.finished; } catch { /* disconnected during turn */ }
        leaf.remove();
        this.busy = false;
      }
      disconnectedCallback() {
        this.events?.abort();
        this.animation?.cancel();
        this.leaf?.remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bandz-society-access"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bandz-member-card')) {
    customElements.define('bandz-member-card',class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();this.controller=new AbortController();
        const options={signal:this.controller.signal};
        const input=this.querySelector('[data-member-input]');
        const name=this.querySelector('[data-member-name]');
        const form=this.querySelector('[data-member-preview]');
        const fallback=name.textContent;
        if(!form)return;
        const update=()=>{name.textContent=input.value.trim()||fallback;};
        input.addEventListener('input',update,options);
        form.addEventListener('submit',event=>{event.preventDefault();update();this.querySelector('[data-member-result]').hidden=false;},options);
        this.querySelector('[data-member-submit]').disabled=false;
      }
      disconnectedCallback(){this.controller?.abort();}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["forever-bandz-luxury-rack"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fb-luxury-rack')) {
    customElements.define('fb-luxury-rack', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.slots = [...this.querySelectorAll('[data-lux-slot]')];
        this.selectors = [...this.querySelectorAll('[data-lux-select]')];
        this.infos = [...this.querySelectorAll('[data-lux-info]')];
        this.querySelectorAll('[data-lux-variant]').forEach(select => {
          select.addEventListener('change', () => {
            select.closest('[data-lux-info]').querySelector('[data-lux-price]').textContent = select.selectedOptions[0].dataset.price;
          }, options);
        });
        this.sideButtons = [...this.querySelectorAll('[data-lux-side]')];
        this.intro = this.querySelector('[data-lux-intro]');
        this.selected = this.querySelector('[data-lux-selected]');
        this.sides = this.querySelector('[data-lux-sides]');
        this.shop = this.querySelector('[data-lux-shop]');
        const stage = this.querySelector('[data-lux-stage]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.swings = new Map();
        let touchStart;
        let lastSwipe = -Infinity;

        this.selectors.forEach(link => {
          link.addEventListener('click', event => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            if (performance.now() - lastSwipe < 420) return;
            const index = Number(link.dataset.luxSelect);
            if (index === this.active && link.hasAttribute('data-lux-pick')) {
              this.turn(!this.slots[index].hasAttribute('data-lux-flipped'));
            } else {
              this.choose(index);
            }
          }, options);
        });
        this.querySelectorAll('[data-lux-pick]').forEach((pick, index) => {
          pick.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse' && this.active < 0) this.sway(index);
          }, options);
        });
        this.sideButtons.forEach(button => {
          button.addEventListener('click', () => this.turn(button.dataset.luxSide === 'back'), options);
        });
        this.querySelector('[data-lux-reset]').addEventListener('click', () => {
          this.querySelector(`.lux-rack__pieces [data-lux-select="${this.active}"]`)?.focus({ preventScroll: true });
          this.choose(-1);
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || this.active < 0) return;
          this.querySelector('[data-lux-reset]').click();
        }, options);
        stage.addEventListener('touchstart', event => {
          touchStart = event.touches.length === 1 ? event.touches[0] : null;
        }, { ...options, passive: true });
        stage.addEventListener('touchcancel', () => { touchStart = null; }, options);
        stage.addEventListener('touchend', event => {
          if (!touchStart) return;
          const touch = event.changedTouches[0];
          const dx = touch.clientX - touchStart.clientX;
          const dy = touch.clientY - touchStart.clientY;
          touchStart = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < 1.25 * Math.abs(dy)) return;
          lastSwipe = performance.now();
          const count = this.slots.length;
          const next = this.active < 0 ? (dx < 0 ? 0 : count - 1) : (this.active + (dx < 0 ? 1 : count - 1)) % count;
          this.choose(next);
        }, { ...options, passive: true });

        this.setAttribute('data-lux-ready', '');
        this.querySelector('[data-lux-panel]').hidden = false;
        this.active = -1;
        this.choose(-1);
      }

      disconnectedCallback() {
        this.swings?.forEach(animation => animation.cancel());
        this.events?.abort();
      }

      sway(index) {
        if (index < 0 || this.motion.matches || this.closest('.society')?.dataset.motion === 'false') return;
        this.swings.get(index)?.cancel();
        const flow = this.slots[index].querySelector('[data-lux-flow]');
        const animation = flow.animate([
          { transform: 'rotateZ(0deg)' },
          { transform: 'rotateZ(-2.3deg)', offset: .2 },
          { transform: 'rotateZ(1.4deg)', offset: .48 },
          { transform: 'rotateZ(-.55deg)', offset: .74 },
          { transform: 'rotateZ(0deg)' }
        ], { duration: 1250, easing: 'ease-in-out' });
        this.swings.set(index, animation);
      }

      choose(index) {
        if (this.active !== index) {
          this.sway(this.active);
          this.sway(index);
          this.turn(false);
        }
        this.active = index;
        const current = this.slots[index];
        this.toggleAttribute('data-lux-active', Boolean(current));
        this.slots.forEach((slot, i) => slot.toggleAttribute('data-lux-current', i === index));
        this.selectors.forEach(link => {
          if (Number(link.dataset.luxSelect) === index) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        this.infos.forEach((info, i) => { info.hidden = i !== index; });
        this.intro.hidden = Boolean(current);
        this.selected.hidden = !current;
        if (!current) return;
        this.shop.href = current.querySelector('[data-lux-pick]').href;
        this.sides.hidden = !current.querySelector('[data-lux-back]');
      }

      turn(back) {
        const current = this.slots[this.active];
        const backFace = current?.querySelector('[data-lux-back]');
        if (!backFace) return;
        this.sway(this.active);
        current.toggleAttribute('data-lux-flipped', back);
        current.querySelector('[data-lux-front]').setAttribute('aria-hidden', String(back));
        backFace.setAttribute('aria-hidden', String(!back));
        this.sideButtons.forEach(button => {
          button.setAttribute('aria-pressed', String((button.dataset.luxSide === 'back') === back));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["society-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('society-film')) {
    customElements.define('society-film', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.video = this.querySelector('video');
        this.button = this.querySelector('.society-film__toggle');
        this.soundButton = this.querySelector('.society-film__sound');
        this.soundEnabled = this.dataset.sound === 'true';
        this.soundOff = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.manualPlay = false;
        this.visible = !('IntersectionObserver' in window);
        this.video.autoplay = false;
        this.video.muted = true;
        this.button.hidden = false;
        if (this.soundButton && this.soundEnabled) this.soundButton.hidden = false;
        this.updateButton = () => {
          const paused = this.video.paused;
          this.button.setAttribute('aria-pressed', String(paused));
          this.button.setAttribute('aria-label', paused ? this.button.dataset.play : this.button.dataset.pause);
        };
        this.updateSound = () => {
          if (!this.soundButton) return;
          const muted = this.video.muted;
          this.soundButton.setAttribute('aria-pressed', String(!muted));
          this.soundButton.setAttribute('aria-label', muted ? this.soundButton.dataset.unmute : this.soundButton.dataset.mute);
        };
        this.disarmUnlock = () => {
          this.unlockController?.abort();
          this.unlockController = null;
        };
        this.tryUnmute = () => {
          if (!this.soundEnabled || this.soundOff || this.video.paused) return;
          this.video.muted = false;
          Promise.resolve(this.video.play()).then(() => {
            if (!this.video.muted) this.disarmUnlock();
            this.updateSound();
          }).catch(() => {
            this.video.muted = true;
            this.video.play().catch(() => {});
            this.updateSound();
          });
        };
        this.armUnlock = () => {
          if (!this.soundEnabled || this.soundOff || this.unlockController) return;
          this.unlockController = new AbortController();
          const options = { passive: true, signal: this.unlockController.signal };
          ['pointerdown', 'pointerup', 'mousedown', 'touchend', 'click', 'keydown'].forEach(name => document.addEventListener(name, this.tryUnmute, options));
        };
        this.playFilm = () => {
          if (!this.loaded) {
            this.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
            this.video.load();
            this.loaded = true;
          }
          this.video.muted = !this.soundEnabled || this.soundOff;
          Promise.resolve(this.video.play()).then(() => {
            this.updateSound();
            if (this.video.muted) this.armUnlock();
          }).catch(() => {
            if (this.video.muted) { this.updateButton(); this.updateSound(); return; }
            this.video.muted = true;
            this.video.play().then(() => { this.armUnlock(); this.updateSound(); }).catch(() => { this.updateButton(); this.updateSound(); });
          });
        };
        this.sync = () => {
          const allowMotion = !this.motion.matches && !navigator.connection?.saveData && this.dataset.autoplay !== 'false';
          if (!document.hidden && this.visible && !this.userPaused && (this.manualPlay || allowMotion)) this.playFilm();
          else this.video.pause();
        };
        this.video.addEventListener('playing', () => { this.classList.add('is-playing'); this.updateButton(); }, { signal });
        this.video.addEventListener('pause', this.updateButton, { signal });
        this.video.addEventListener('volumechange', this.updateSound, { signal });
        this.video.addEventListener('error', () => { this.classList.remove('is-playing'); this.button.hidden = true; if (this.soundButton) this.soundButton.hidden = true; }, { signal });
        this.button.addEventListener('click', () => {
          if (this.video.paused) { this.userPaused = false; this.manualPlay = true; this.playFilm(); }
          else { this.userPaused = true; this.manualPlay = false; this.video.pause(); }
        }, { signal });
        this.soundButton?.addEventListener('click', () => {
          if (this.video.muted) {
            this.soundOff = false;
            if (this.video.paused) { this.userPaused = false; this.manualPlay = true; this.playFilm(); }
            else this.tryUnmute();
          } else {
            this.soundOff = true;
            this.video.muted = true;
            this.disarmUnlock();
          }
          this.updateSound();
        }, { signal });
        window.matchMedia('(max-width: 749px)').addEventListener('change', () => { if (this.loaded) { this.video.load(); this.sync(); } }, { signal });
        this.motion.addEventListener('change', () => { this.manualPlay = false; this.sync(); }, { signal });
        document.addEventListener('visibilitychange', this.sync, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: .05 });
          this.observer.observe(this);
        }
        this.updateButton();
        this.updateSound();
        this.sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.unlockController?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["society-script-logo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('st-bandz-script')) {
    customElements.define('st-bandz-script', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.anchor = this.closest('.society-film') || this;
        this.visible = !('IntersectionObserver' in window);
        this.frame = 0;
        this.queue = () => {
          if (this.frame || !this.visible || this.motion.matches || document.hidden) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            const bounds = this.anchor.getBoundingClientRect();
            const viewport = window.innerHeight;
            const isBanner = this.classList.contains('st-bandz-script--banner');
            const progress = isBanner
              ? (viewport * .14 - bounds.top) / (bounds.height + viewport * .14)
              : (viewport - bounds.top) / (viewport * .55);
            const clamped = Math.max(0, Math.min(1, progress));
            const position = -140 + clamped * 380;
            const glow = Math.sin(Math.PI * Math.min(1, Math.max(0, (clamped - .263) / .474)));
            this.style.setProperty('--st-bandz-shine', `${position.toFixed(2)}%`);
            this.style.setProperty('--st-bandz-glow', glow.toFixed(2));
          });
        };
        const signal = this.controller.signal;
        document.addEventListener('scroll', this.queue, { passive: true, capture: true, signal });
        window.addEventListener('resize', this.queue, { passive: true, signal });
        document.addEventListener('visibilitychange', this.queue, { signal });
        this.motion.addEventListener('change', () => {
          cancelAnimationFrame(this.frame);
          this.frame = 0;
          this.style.removeProperty('--st-bandz-shine');
          this.style.removeProperty('--st-bandz-glow');
          this.queue();
        }, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            if (this.visible) this.queue();
          }, { rootMargin: '80px 0px' });
          this.observer.observe(this.anchor);
        }
        this.queue();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
